export type Recipient = 'mama' | 'dasha';

export function getRecipient(): Recipient {
  if (typeof window === 'undefined') return 'mama';
  const params = new URLSearchParams(window.location.search);
  const recipient = params.get('for');
  return recipient === 'dasha' ? 'dasha' : 'mama'; // default: mama
}

export function getRecipientName(recipient: Recipient): string {
  return recipient === 'dasha' ? 'Даши' : 'мамы';
}

export function getCompanionName(recipient: Recipient): string {
  return recipient === 'dasha' ? 'мамы Лены' : 'Даши';
}
